import React from 'react';
import BackspaceIcon from '@mui/icons-material/Backspace';
import KeyboardReturnIcon from '@mui/icons-material/KeyboardReturn';
import '../styles/NumberKeyboard.scss';

export default function NumberKeyboard({onFormSubmit, onKeyPress, negate}) {
  const onClick = ({target}) => {
    onKeyPress(target.value);
  };
  return <div className="number-keyboard">
    <button type="button" value="1" className="btn-1" onClick={onClick}>1</button>
    <button type="button" value="2" className="btn-2" onClick={onClick}>2</button>
    <button type="button" value="3" className="btn-3" onClick={onClick}>3</button>
    <button type="button" value="4" className="btn-4" onClick={onClick}>4</button>
    <button type="button" value="5" className="btn-5" onClick={onClick}>5</button>
    <button type="button" value="6" className="btn-6" onClick={onClick}>6</button>
    <button type="button" value="7" className="btn-7" onClick={onClick}>7</button>
    <button type="button" value="8" className="btn-8" onClick={onClick}>8</button>
    <button type="button" value="9" className="btn-9" onClick={onClick}>9</button>
    <button type="button" value="0" className="btn-0" onClick={onClick}>0</button>
    {negate ? (
      <button type="button" value="-" className="btn-negate" onClick={onClick}>+/-</button>
    ) : null}
    <button type="button" value="." className="btn-period" onClick={onClick}>.</button>
    <button type="button" value="del" className="btn-delete" onClick={onClick}><BackspaceIcon /></button>
    <button type="button" value="ret" className="btn-return" onClick={onFormSubmit}><KeyboardReturnIcon /></button>
  </div>;
}
